/* tslint:disable */
/* eslint-disable */
/**
 * Chatbot API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/**
 * 
 * @export
 * @interface ConfigurationFeatures
 */
export interface ConfigurationFeatures {
    /**
     * Výchozí rozbalenost / sbalenost chatbota
     * @type {boolean}
     * @memberof ConfigurationFeatures
     */
    defaultOpen: boolean;
    /**
     * Pamatování si posledního stavu rozbalenosti chatbota
     * @type {boolean}
     * @memberof ConfigurationFeatures
     */
    memoOpen: boolean;
    /**
     * Automatické skrývání / otevírání chatbota po kliknutí na vygenerovaný odkaz
     * @type {string}
     * @memberof ConfigurationFeatures
     */
    onChatLinkClickAction?: ConfigurationFeaturesOnChatLinkClickActionEnum;
    /**
     * Otevírání odkazů na stejné doméně ve stejném/novém okně
     * @type {string}
     * @memberof ConfigurationFeatures
     */
    internalLinksTarget: ConfigurationFeaturesInternalLinksTargetEnum;
    /**
     * Otevírání odkazů na jiné doméně ve stejném/novém okně
     * @type {string}
     * @memberof ConfigurationFeatures
     */
    externalLinksTarget: ConfigurationFeaturesExternalLinksTargetEnum;
    /**
     * Styl zavírání chatbota (křížek/ikonkou chatbota)
     * @type {string}
     * @memberof ConfigurationFeatures
     */
    closeMode: ConfigurationFeaturesCloseModeEnum;
    /**
     * Rozložení prvků v patičce chatbota
     * @type {string}
     * @memberof ConfigurationFeatures
     */
    footerMode: ConfigurationFeaturesFooterModeEnum;
    /**
     * Čas po kterém na sebe chatbot upozorní
     * @type {number}
     * @memberof ConfigurationFeatures
     */
    alertTimer?: number;
    /**
     * Počet řádků, které se zobrazí u příchozí zprávy.
     * @type {number}
     * @memberof ConfigurationFeatures
     */
    incommingMessageShowRows?: number;
}

/**
    * @export
    * @enum {string}
    */
export enum ConfigurationFeaturesOnChatLinkClickActionEnum {
    AutoClose = 'AutoClose',
    AutoOpen = 'AutoOpen'
}
/**
    * @export
    * @enum {string}
    */
export enum ConfigurationFeaturesInternalLinksTargetEnum {
    Self = 'self',
    New = 'new'
}
/**
    * @export
    * @enum {string}
    */
export enum ConfigurationFeaturesExternalLinksTargetEnum {
    Self = 'self',
    New = 'new'
}
/**
    * @export
    * @enum {string}
    */
export enum ConfigurationFeaturesCloseModeEnum {
    X = 'X',
    Expander = 'expander'
}
/**
    * @export
    * @enum {string}
    */
export enum ConfigurationFeaturesFooterModeEnum {
    RIS = 'RIS',
    ISR = 'ISR'
}

